import Swiper from "swiper/bundle";

export const SubscriptionPoints = () => {
    const $subscriptionPoints = document.querySelector(
        "section.subscription-points"
    );
    if ($subscriptionPoints) {
        const $subscriptionPopularWrapper = $subscriptionPoints.querySelector(
            ".subscription-points__wrapper"
        );

        const $wrapperContents =
            $subscriptionPopularWrapper?.querySelector(".wrapper__contents");

        const $wrapperInfo = $subscriptionPopularWrapper?.querySelector(
            ".subscription-points__info"
        );

        const $infoNav = $wrapperInfo?.querySelector(".info__nav");
        const $navLeft = $infoNav?.querySelector(".nav__left");
        const $navRight = $infoNav?.querySelector(".nav__right");

        const $wrapperSwiper = $subscriptionPopularWrapper.querySelector(
            ".subscription-points__items.subscription-points__items--mobile.swiper"
        );
        if ($wrapperSwiper) {
            const swiperConfig = {
                direction: "horizontal",
                speed: 1000,
                slidesPerView: 1.2,
                slidesPerGroup: 1,
                spaceBetween: 12,
                centeredSlides: true,
            };
            if ($navLeft && $navRight) {
                swiperConfig.navigation = {
                    nextEl: $navRight,
                    prevEl: $navLeft,
                };
            }
            const swiperObject = new Swiper($wrapperSwiper, swiperConfig);
        }
    }
};

export default SubscriptionPoints;